import React, { useState, useEffect } from "react";
import Commonheader from "./Commonheader";
import useAxios from "../hooks/useAxios";
import { Tabs } from "antd";

const { TabPane } = Tabs;

function Unblock_user(props) {
  const [loading, sendRequest] = useAxios();
  const [isErrOpen, setisErrOpen] = useState(false);
  const [api_error_message, setapi_error_message] = useState();
  const [user_id, setuser_id] = useState();
  const [deactivateUser, setDeactivateUser] = useState();
  const [deactivationReasons, setDeactivationReasons] = useState([]);
  const [selectedReason, setSelectedReason] = useState("");
  
  // New state for enhanced fields
  const [dateOfSeparation, setDateOfSeparation] = useState("");
  const [revokeRemarks, setRevokeRemarks] = useState("");
  const [remarks, setRemarks] = useState("");
  const [suspensionEndDate, setSuspensionEndDate] = useState("");

const showDateOfSeparation = selectedReason === "9" || selectedReason === "11" || selectedReason === "12" || selectedReason === "14";

const showRevokeRemarks = ["13", "15"].includes(selectedReason);

  useEffect(() => {
    fetchDeactivationReasons();
  }, []);

  const fetchDeactivationReasons = () => {
    let apitoken = localStorage.getItem("api_token");
    sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/employee/transaction/types`,
        method: "GET",
        headers: {
          "api-token": apitoken,
        },
      },
      (response) => {
        if (response.status === 1) {
          setDeactivationReasons(response.data);
        } else {
          setapi_error_message(response.message);
        }
      }
    );
  };

  const unblock_userid = () => {
    let apitoken = localStorage.getItem("api_token");
    let formData = new FormData();
    formData.append("username", user_id);
    sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/unblock/user`,
        method: "POST",
        headers: {
          "api-token": apitoken,
        },
        data: formData,
      },
      (response) => {
        setisErrOpen(true);
        setapi_error_message(response.message);
      }
    );
  };

  const deactivate_user = () => {
    let apitoken = localStorage.getItem("api_token");
    
    // Prepare payload
    let payload = {
      reason: selectedReason,
      remarks: remarks || "User deactivated",
    };
    
    // Determine if input is username or userid
    if (/[a-zA-Z]/.test(deactivateUser) && /\d/.test(deactivateUser)) {
      payload.username = deactivateUser;
    } else {
      payload.userid = deactivateUser;
    }
    
    // Add conditional fields
    if (showDateOfSeparation && dateOfSeparation) {
      payload.date_of_separation = dateOfSeparation;
    }
    
    if (selectedReason === "14" && suspensionEndDate) {
      payload.suspension_end_date = suspensionEndDate;
    }
    
    if (showRevokeRemarks && revokeRemarks) {
      payload.revoke_remarks = revokeRemarks;
    }
    
    sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/deactivate_user`,
        method: "POST",
        data: payload,
        headers: {
          "Content-Type": "application/json",
          "api-token": apitoken,
        },
      },
      (response) => {
        setisErrOpen(true);
        setapi_error_message(response.message);
      }
    );
  };

  return (
    <div className="container">
      <Commonheader pagetitle={"De-activate/Unblock User"} props={props} />
      {loading && (
        <div className="load-4">
          <div className="ring-1"></div>
        </div>
      )}
      <div
        className={
          isErrOpen
            ? "modal fade show d-block mymodal"
            : "modal fade bd-example-modal-sm"
        }
        tabIndex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
        id="confirm-box"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content cdb-confirm-box col-sm-12">
            <button
              type="button"
              className="close text-right"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                setisErrOpen(false);
                // Removed window.location.reload() - stays on current tab
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <p className="popuperrtext">{api_error_message}</p>
          </div>
        </div>
      </div>

      <Tabs defaultActiveKey="2">
        <TabPane tab="Unblock" key="1">
          <div className="mt-4">
            <div className="row">
              <div className="col-md-4">
                <input
                  placeholder="Enter Id"
                  className="form-control"
                  onChange={(e) => setuser_id(e.target.value)}
                />
              </div>
              <div className="col-md-2">
                <button
                  className="btn btn-primary"
                  onClick={() => unblock_userid()}
                >
                  Unblock
                </button>
              </div>
            </div>
          </div>
        </TabPane>
        <TabPane tab="De-activate" key="2">
          <div className="mt-4">
            <div className="row">
              <div className="col-md-4">
                <input
                  placeholder="User Id/Name"
                  className="form-control"
                  onChange={(e) => setDeactivateUser(e.target.value)}
                />
              </div>
              <div className="col-md-4">
                <select
                  className="form-control"
                  onChange={(e) => {
                    setSelectedReason(e.target.value);
                    // Reset dependent fields when reason changes
                    setDateOfSeparation("");
                    setRevokeRemarks("");
                    setSuspensionEndDate(""); // Reset end date
                  }}
                  value={selectedReason}
                >
                  <option value="">Deactivation Reason</option>
                  {deactivationReasons.map((reason, index) => (
                    <option
                      key={index}
                      value={reason.employee_transaction_type_id}
                    >
                      {reason.employee_transaction_type_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            
            {/* Conditional fields - Date of Separation */}
            {showDateOfSeparation && (
              <div className="row mt-3">
                <div className="col-md-4">
                  <label className="form-label fw-bold">Date of Separation</label>
                  <input
                    type="date"
                    className="form-control"
                    value={dateOfSeparation}
                    onChange={(e) => setDateOfSeparation(e.target.value)}
                  />
                </div>
              </div>
            )}
            
            {/* Conditional fields - Suspension End Date */}
            {selectedReason === "14" && dateOfSeparation && (
              <div className="row mt-3">
                <div className="col-md-4">
                  <label className="form-label fw-bold">Suspension End Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={suspensionEndDate}
                    onChange={(e) => setSuspensionEndDate(e.target.value)}
                    min={dateOfSeparation}
                  />
                  <small className="text-muted">Leave empty for indefinite suspension</small>
                </div>
              </div>
            )}
            
            {/* Revoke Remarks */}
            {showRevokeRemarks && (
              <div className="row mt-3">
                <div className="col-md-4">
                  <label className="form-label fw-bold">Revoke Remarks</label>
                  <textarea
                    className="form-control"
                    placeholder="Enter revoke remarks (required)"
                    rows="2"
                    value={revokeRemarks}
                    onChange={(e) => setRevokeRemarks(e.target.value)}
                  />
                </div>
              </div>
            )}
            
            {/* Additional Remarks - always shown */}
            <div className="row mt-3">
              <div className="col-md-4">
                <label className="form-label fw-bold">Additional Remarks</label>
                <textarea
                  className="form-control"
                  placeholder="Additional remarks (optional)"
                  rows="2"
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                />
              </div>
            </div>
            
            <div className="row mt-3">
              <div className="col-md-2">
                <button
                  className="btn btn-primary"
                  onClick={() => deactivate_user()}
                >
                      Submit
                </button>
              </div>
            </div>
          </div>
        </TabPane>
      </Tabs>
    </div>
  );
}

export default Unblock_user;